module.exports = __webpack_public_path__ + "img/acid_picdump_100.44149934.jpg";